var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"i-frame-viewer",attrs:{"id":_vm._uid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }